export const DEAL_UPDATE = 'DEAL_UPDATE';
export const TRANSACTION_UPDATE = 'TRANSACTION_UPDATE';

export const SELF_EMPLOYED_APPROVAL = 'SELF_EMPLOYED_APPROVAL';
export const TELEGRAM_SUBSCRIPTION = 'TELEGRAM_SUBSCRIPTION';
export const TELEGRAM_UNSUBSCRIPTION = 'TELEGRAM_UNSUBSCRIPTION';
export const TELEGRAM_TWO_FACTOR_CONFIRMATION = 'TELEGRAM_TWO_FACTOR_CONFIRMATION';

export const BOT_SIGN_ON_EVENT = 'BOT_SIGN_ON_EVENT';
export const BOT_SIGN_OFF_EVENT = 'BOT_SIGN_OFF_EVENT';

export const IDENTIFICATION_STATUS_CHANGE = 'IDENTIFICATION_STATUS_CHANGE';
export const TRANSACTION_BROWSING_APPROVAL = 'TRANSACTION_BROWSING_APPROVAL';

export const PARTNER_DATA_KEY = 'partnerData';
